import { ArrowUpRight, Mail, Globe } from "lucide-react";
import { SITE, mailto } from "../../content";
import { Eyebrow, Reveal } from "./Primitives";

export const Contact = () => (
  <section id="kontakt" data-testid="contact-section" className="bg-navy py-24 text-white sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow dark>Kontakt</Eyebrow>
        <h2 className="mt-6 max-w-4xl text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] sm:text-5xl lg:text-6xl">
          Wir freuen uns <span className="font-light italic text-sky-200">auf Ihre Nachricht.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <a
          href={mailto("Anfrage über die Website")}
          data-testid="contact-email-cta"
          className="group mt-14 flex flex-col gap-6 border-y border-white/15 py-10 sm:flex-row sm:items-center sm:justify-between"
        >
          <span className="break-all text-2xl font-light tracking-tight transition-colors group-hover:text-sky-200 sm:text-4xl lg:text-5xl">{SITE.email}</span>
          <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white text-navy transition-transform duration-500 group-hover:rotate-45">
            <ArrowUpRight className="h-6 w-6" />
          </span>
        </a>
      </Reveal>
      <div className="mt-10 grid gap-8 text-sm sm:grid-cols-2">
        <div className="flex items-start gap-3">
          <Mail className="mt-0.5 h-4 w-4 text-sky-300" />
          <a href={`mailto:${SITE.email}`} data-testid="contact-email-link" className="text-slate-200 hover:text-white">{SITE.email}</a>
        </div>
        <div className="flex items-start gap-3">
          <Globe className="mt-0.5 h-4 w-4 text-sky-300" />
          <a href={SITE.url} data-testid="contact-website-link" className="text-slate-200 hover:text-white">schwimmschulemanta.de</a>
        </div>
      </div>
    </div>
  </section>
);
